<template>
  <div>
    <div class="zl-plan">
      <!--  style="background-color:#e3f7f0" -->
      <van-cell @click="showPopup">
        <div class="icon">
          <!--  -->
          <span class="help">助学</span>
          <span class="title"><img class="my_img" src="/icon/green_xin.png" alt="">筑龙助学计划</span>
        </div>
      </van-cell>
      <van-popup v-model="show" position="bottom">
        <div style="height:200px;background-color:#fff;position: relative;">
          <img src="@/assets/img/zhuxue.jpg" alt="" style="width:100%;height:100%;">
          <div class="close" @click="close"></div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
/*
 *  date:2021/6/15
 *  authour:li yao
 *  describe:筑龙计划组件
 */
export default {
  name: 'ZLPlan',
  data() {
    return {
      show: false
    }
  },
  methods: {
    close() {
      this.show = false
    },
    showPopup() {
      this.show = true
    }
  }
}
</script>
<style scoped lang='scss'>
.close{
  width: 50px;
  height: 50px;
  // background: chocolate;
  position: absolute;
  right: 0;
  top: 0;
}
.my_img{
  width: 35px;
  height: 30px;
  padding-left: 3px;
}
.title{
  color:#229f75;
  letter-spacing: 3px;
  padding-left: 50px;
  font-size: 30px;
  img{
    margin-right: 8px;
    vertical-align: middle;
  }
}
.zl-plan {
  .icon{
      // display: flex;
      align-items: center;
      .help{
        font-size: 30px;
      }
    // span{
    //     margin-right: 12px;
    // }

  }
  display: flex;
  justify-content: space-between;
  line-height: 87px;
  width: 100%;
  align-items: center;
  background: #E3F7F0;
  // span {
  //   flex: 0.8;
  // }
}
</style>
